<template>
  <v-card id="lead-quoted-list">
    <v-card-text class="d-flex align-center lead-appbar-color flex-wrap pb-0">
      <h2
        style="color: white !important;"
        class="mb-4"
      >
        Quoted leads
      </h2>
      <v-spacer></v-spacer>
      <div class="d-flex align-center pb-5">
        <!-- search request -->
        <v-tooltip
          :left="$vuetify.breakpoint.smAndUp"
          :top="$vuetify.breakpoint.xsOnly"
          :nudge-bottom="$vuetify.breakpoint.smAndUp ? 20 : 0"
          :nudge-top="$vuetify.breakpoint.xsOnly ? 5 : 0"
          :nudge-right="$vuetify.breakpoint.xsOnly ? 100 : 0"
          max-width="250"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-avatar
              size="30"
              class="mr-3 hover-pointer"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                color="white"
                size="25"
              >
                {{ icons.mdiAlertCircleOutline }}
              </v-icon>
            </v-avatar>
          </template>
          <h3 class="my-2">
            {{ t('How to use the search bar') }}
          </h3>
          <p class="mb-1">
            {{ t('You can search using') }}:
          </p>
          <ul class="mb-2">
            <li>
              {{ t('Car Registration No.') }}
            </li>
            <li>
              {{ t('Customer Name') }}
            </li>
            <li v-if="userTeam !== 'Quotation Main Lead' && userTeam !== 'Quotation Assistant'">
              {{ t('Contact No.') }}
            </li>
          </ul>
        </v-tooltip>
        <v-text-field
          v-model="searchText"
          :append-icon="icons.mdiMagnify"
          single-line
          dense
          outlined
          hide-details
          :placeholder="t('Search Lead')"
          class="lead-appbar-item"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-divider></v-divider>

    <!-- table -->
    <v-data-table
      :headers="userTeam === 'Quotation Assistant' ? quotedHideTableColumns : quotedTableColumns"
      :items="leads"
      :items-per-page="100"
      :loading="loading"
      hide-default-footer
      :disable-sort="true"
      mobile-breakpoint="0"
      class="text-no-wrap"
    >
      <!-- Actions -->
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center">
          <!-- Download Docs -->
          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="userTeam === 'General Main Lead' || userTeam === 'Quotation Main Lead'"
                :loading="downloadLoading && currentDownloadId === item.id"
                :disabled="downloadLoading"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="downloadPdf(item)"
              >
                <v-icon size="18">
                  {{ icons.mdiDownload }}
                </v-icon>
              </v-btn>
            </template>
            <span>Download pdf</span>
          </v-tooltip>

          <!-- Copy -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="userTeam === 'General Main Lead' || userTeam === 'Quotation Main Lead'"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="copyWhatsappText(item.whatsapp_template, item)"
              >
                <v-icon size="18">
                  {{ icons.mdiContentCopy }}
                </v-icon>
              </v-btn>
            </template>
            <span>Copy whatsapp text</span>
          </v-tooltip>

          <!-- View -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'apps-lead-edit',
                  params: { id: item.id }
                }"
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiEyeOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>

          <!-- View -->
          <v-tooltip
            v-if="userTeam === 'Quotation Main Lead' || userTeam === 'Quotation Assistant' || item.created_by_id === userData.id"
            bottom
          >
            <template #activator="{ on, attrs }">
              <v-btn
                :to="{
                  name: 'apps-lead-edit',
                  params: { id: item.id, quote_edit: true }
                }"
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>
              Edit
            </span>
          </v-tooltip>

          <!-- Void -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="item.created_by_id === userData.id || userTeam === 'Quotation Main Lead' || userTeam === 'Quotation Assistant'"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="voidableLead = item; isVoidDialogVisible = true"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Void</span>
          </v-tooltip>

          <!-- View Previous Policy -->
          <v-tooltip
            v-if="item.previous_policy_url !== 'NULL'"
            bottom
          >
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :href="item.previous_policy_url"
                target="_blank"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiFileDocument }}
                </v-icon>
              </v-btn>
            </template>
            <span>View previous policy</span>
          </v-tooltip>
          <v-tooltip
            v-else
            bottom
          >
            <template #activator="{ on }">
              <div v-on="on">
                <v-btn
                  icon
                  small
                  disabled
                >
                  <v-icon size="18">
                    {{ icons.mdiHelpCircleOutline }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <span>No previous policy attached</span>
          </v-tooltip>

          <!-- Proceed To Issue -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-if="userTeam === 'General Main Lead' || userTeam === 'Quotation Main Lead'"
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="issueLead = item; isIssueDialogVisible = true; proceedToIssuePaymentMethodId = null; proceedLead = {
                  payment_screenshot: null,
                  visa_receipt: null,
                  trace_number: null,
                  partial_card_number: null,
                }"
              >
                <v-icon size="18">
                  {{ icons.mdiArrowRightBox }}
                </v-icon>
              </v-btn>
            </template>
            <span>Proceed to issue</span>
          </v-tooltip>
        </div>
      </template>

      <!-- Status -->
      <template #[`item.status`]="{item}">
        <v-chip :color="item.status === 'Quoted' ? '#f0cc00' : '#81C784'">
          {{ item.status }}
        </v-chip>
      </template>
    </v-data-table>

    <!-- Void dialog -->
    <v-dialog
      v-model="isVoidDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title
          v-if="voidableLead"
          class="d-flex align-center mv-4"
        >
          Void lead for {{ voidableLead.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isVoidDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          This lead will be voided. It won't be taken into any calculations.
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="error"
            block
            :loading="voidLoading"
            :disabled="voidLoading"
            class="mt-3"
            @click="voidLead()"
          >
            Yes, remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Issue dialog -->
    <v-dialog
      v-model="isIssueDialogVisible"
      width="500"
    >
      <v-card>
        <v-card-title
          v-if="issueLead"
          class="d-flex align-center mv-4"
        >
          Proceed to issue for {{ issueLead.name }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="isIssueDialogVisible = false"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div>This lead will be set to issue. Please select Payment Method</div>

          <v-row class="mt-1">
            <v-col
              cols="6"
              class="my-auto"
            >
              <div class="font-weight-semibold">
                Payment By:
              </div>
            </v-col>
            <v-col
              cols="6"
            >
              <v-select
                v-model="proceedToIssuePaymentMethodId"
                :items="paymentMethodOptions"
                item-value="id"
                item-text="name"
                single-line
                outlined
                dense
                hide-details
                clearable
                placeholder="Select Payment Method"
                @change="clearPaymentDetailNumbers()"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <!-- Bank Payment Screenshot -->
            <v-col
              v-if="proceedToIssuePaymentMethodId == 1 || proceedToIssuePaymentMethodId == 2"
              cols="6"
              class="pt-0 my-auto"
            >
              <div class="font-weight-semibold">
                Bank Payment Screenshot:
              </div>
            </v-col>
            <v-col
              v-if="proceedToIssuePaymentMethodId == 1 || proceedToIssuePaymentMethodId == 2"
              col="6"
              class="pt-0"
            >
              <v-file-input
                prepend-icon=""
                :append-icon="icons.mdiPaperclip"
                accept="application/pdf, image/png, image/jpg, image/jpeg"
                show-size
                dense
                outlined
                :rules="paymentScreenshotRules"
                placeholder="Upload payment screenshot"
                hide-details="auto"
                @change="directUploadScreenshot($event)"
              >
                <template v-slot:selection="{ text }">
                  <v-chip
                    small
                    label
                    color="primary"
                  >
                    {{ text }}
                  </v-chip>
                </template>

                <template v-slot:append>
                  <v-progress-circular
                    v-if="uploadScreenshotLoading"
                    color="primary"
                    indeterminate
                    size="25"
                  ></v-progress-circular>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            block
            :loading="issueLoading"
            :disabled="issueLoading || !(proceedToIssuePaymentMethodId === 3) && !(proceedToIssuePaymentMethodId === 5) &&
              !((proceedToIssuePaymentMethodId === 1 || proceedToIssuePaymentMethodId === 2) && proceedLead.payment_screenshot)
            "
            class="mt-3"
            @click="proceedToIssue()"
          >
            Yes, confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text class="pt-5">
      <v-row>
        <v-col
          lg="2"
          cols="3"
        >
          <div class="d-flex align-center">
            <v-select
              v-model="tablePagination.per"
              :items="listLengthOptions"
              single-line
              outlined
              dense
              hide-details
              class="lead-list-row-selection"
              @input="listLengthChange()"
            ></v-select>
            <div class="pl-3">
              {{ t('Rows') }}
            </div>
          </div>
        </v-col>

        <v-col
          lg="10"
          cols="9"
          class="d-flex justify-end"
        >
          <v-pagination
            v-model="tablePagination.current_page"
            total-visible="6"
            :length="tablePagination.total_page"
            @input="pageChange()"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiDownload,
  mdiPencilOutline,
  mdiDeleteOutline,
  mdiAlertCircleOutline,
  mdiMagnify,
  mdiEyeOutline,
  mdiClose,
  mdiFileDocumentOutline,
  mdiFileDocument,
  mdiContentCopy,
  mdiHelpCircleOutline,
  mdiArrowRightBox,
} from '@mdi/js'
import {
  onMounted,
  onUnmounted,
  ref,
  inject,
  watch,
  computed,
} from '@vue/composition-api'

// import notificationService from '@/services/notification.service'
import leadStoreModule from './leadStoreModule'
import receiptStoreModule from '../receipt/receiptStoreModule'

export default {
  setup() {
    // Initializers
    const store = inject('store')
    const snackbarService = inject('snackbarService')
    const t = inject('t')
    const can = inject('can')
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userRole = userData && userData.role ? userData.role : null

    const LEAD_APP_STORE_MODULE_NAME = 'app-lead'
    const RECEIPT_APP_STORE_MODULE_NAME = 'app-receipt'

    if (!store.hasModule(LEAD_APP_STORE_MODULE_NAME)) {
      store.registerModule(LEAD_APP_STORE_MODULE_NAME, leadStoreModule)
    }

    if (!store.hasModule(RECEIPT_APP_STORE_MODULE_NAME)) {
      store.registerModule(RECEIPT_APP_STORE_MODULE_NAME, receiptStoreModule)
    }

    // Table Handlers
    const quotedTableColumns = computed(() => (
      [
        { text: t('Actions'), value: 'actions' },
        { text: t('Status'), value: 'status', align: 'center' },
        { text: t('Date Issued'), value: 'created_at' },
        ...(['Auditor', 'Secretary'].includes(userRole)
          ? [{ text: t('Quoted By'), value: 'quoted_by_name' }]
          : []
        ),
        { text: t('Name'), value: 'name' },
        { text: t('Contact No.'), value: 'contact_number' },
        { text: t('Car No.'), value: 'car_registration_number' },
        { text: t('Total'), value: 'total' },
        { text: t('Remarks'), value: 'remarks' },
      ]
    ))
    const quotedHideTableColumns = computed(() => (
      [
        { text: t('Actions'), value: 'actions' },
        { text: t('Status'), value: 'status', align: 'center' },
        { text: t('Date Issued'), value: 'created_at' },
        ...(['Auditor', 'Secretary'].includes(userRole)
          ? [{ text: t('Quoted By'), value: 'quoted_by_name' }]
          : []
        ),
        { text: t('Name'), value: 'name' },
        { text: t('Car No.'), value: 'car_registration_number' },
        { text: t('Total'), value: 'total' },
        { text: t('Remarks'), value: 'remarks' },
      ]
    ))

    // Properties
    const leads = ref([])
    const tablePagination = ref({
      current_page: 1,
      per: 20,
      total_count: 0,
      total_page: 0,
    })
    const listLengthOptions = ref([5, 10, 20])
    const loading = ref(false)
    const isVoidDialogVisible = ref(false)
    const voidableLead = ref({})
    const voidLoading = ref(false)
    const isIssueDialogVisible = ref(false)
    const issueLead = ref({})
    const issueLoading = ref(false)
    const downloadLoading = ref(false)
    const currentDownloadId = ref(null)
    const userTeam = computed(() => store.state.user.team)
    const searchText = ref('')

    const proceedToIssuePaymentMethodId = ref(null)
    const uploadScreenshotLoading = ref(false)
    const uploadVisaReceiptLoading = ref(false)
    const paymentMethodOptions = ref([])
    const proceedLead = ref({
      payment_screenshot: null,
      visa_receipt: null,
      trace_number: null,
      partial_card_number: null,
    })
    const paymentScreenshotRules = [value => !value || value.size < 5000000 || 'Bank payment image has to be lower than 5MB']
    const visaReceiptRules = [value => !value || value.size < 5000000 || 'Visa receipt file has to be lower than 5MB']

    // const appCable = notificationService.webSocketConnection()

    // Methods
    const fetchLeadCounts = () => {
      store
        .dispatch('fetchLeadCounts')
        .then(response => {
          const { data } = response.data
          store.dispatch('setLeadCounts', data)
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching lead counts. Please refresh!')
        })
    }
    const copyWhatsappText = (text, item) => {
      if (item.status === 'Quoted') {
        store
          .dispatch('app-lead/leadInformed', { id: item.id })
          .then(() => {
            navigator.clipboard.writeText(text)
              .then(() => {
                snackbarService.success('Copied!')
              })
              .catch(() => {
                snackbarService.error('Failed to copy')
              })
          })
          .catch(error => {
            snackbarService.error(error.response.data.message || 'Something went wrong while updating lead. Please refresh!')
          })
      } else {
        navigator.clipboard.writeText(text)
          .then(() => {
            snackbarService.success('Copied!')
          })
          .catch(() => {
            snackbarService.error('Failed to copy')
          })
      }
    }
    const isLoading = () => {
      loading.value = true
      snackbarService.info('Loading your list. Please hold...')
    }
    const doneLoading = () => {
      loading.value = false
      snackbarService.success('Done loading your list!')
    }
    const fetchLeads = () => {
      store
        .dispatch('app-lead/fetchLeads', {
          page: tablePagination.value.current_page,
          per: tablePagination.value.per,
          search_text: searchText.value,
          status: ['Quoted', 'Informed'],
        })
        .then(response => {
          const { data, pagination } = response.data
          leads.value = data
          leads.value.forEach(field => {
            Object.keys(field).forEach(key => {
              if (field[key] === null) field[key] = 'NULL'
            })
          })
          tablePagination.value = pagination
          doneLoading()
        })
        .catch(error => {
          loading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching leads. Please refresh!')
        })
    }
    const voidLead = () => {
      voidLoading.value = true
      store
        .dispatch('app-lead/voidLead', { id: voidableLead.value.id })
        .then(response => {
          snackbarService.success(response.data.message)
          fetchLeads()
          isVoidDialogVisible.value = false
          voidLoading.value = false
        })
        .catch(error => {
          voidLoading.value = false
          snackbarService.error(error.data.message || 'Something went wrong while voiding lead. Please refresh!')
        })
    }
    const pageChange = () => {
      isLoading()
      fetchLeads()
    }
    const listLengthChange = () => {
      tablePagination.value.current_page = 1
      isLoading()
      fetchLeads()
    }
    const downloadPdf = lead => {
      downloadLoading.value = true
      currentDownloadId.value = lead.id
      store
        .dispatch('app-lead/downloadPdf', { id: lead.id })
        .then(response => {
          const url = window.URL.createObjectURL(response)
          const a = document.createElement('a')
          a.href = url
          const carNumber = lead.car_registration_number && lead.car_registration_number !== 'NULL' ? `${lead.car_registration_number}_` : ''
          const contactNo = `${lead.contact_number}_`
          a.download = `${carNumber}${contactNo}${lead.created_at.split('/').join('-')}.pdf`
          document.body.appendChild(a)
          a.click()
          a.remove()
          downloadLoading.value = false
        })
        .catch(error => {
          downloadLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while downloading pdf. Please refresh!')
        })
    }
    const proceedToIssue = () => {
      store
        .dispatch('app-lead/proceedToIssue', {
          id: issueLead.value.id,
          lead: {
            payment_screenshot: proceedLead.value.payment_screenshot ? proceedLead.value.payment_screenshot : null,
            metadata: {
              payment_method_id: proceedToIssuePaymentMethodId.value,
              payment_screenshot: proceedLead.value.payment_screenshot,
              payment_screenshot_name: proceedLead.value.payment_screenshot_name,
            },
          },
        })
        .then(response => {
          snackbarService.success(response.data.message)
          issueLoading.value = false
          isIssueDialogVisible.value = false
          fetchLeads()
        })
        .catch(error => {
          issueLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while updating lead. Please refresh!')
        })
    }

    /*
    const updateLeads = () => {
      appCable.subscriptions.create({
        channel: 'LeadChannel',
      },
      {
        connected() {
          console.log('Connected to the leads channel')
        },
        received(data) {
          switch (data.event) {
            case 'new_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'quoted_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'refresh_leads':
              fetchLeads()
              fetchLeadCounts()
              break
            case 'issue_lead':
              fetchLeads()
              fetchLeadCounts()
              break
            default:
          }
        },
        disconnected() {
          console.log('Disconnected from leads channel')
        },
      })
    }
    */

    const fetchPaymentMethods = () => {
      store
        .dispatch('app-receipt/fetchPaymentMethods')
        .then(response => {
          const { data } = response.data
          paymentMethodOptions.value = data
        })
        .catch(error => {
          snackbarService.error(error.response.data.message || 'Something went wrong while fetching payment methods. Please refresh!')
        })
    }
    const directUploadScreenshot = file => {
      if (file == null) {
        proceedLead.value.payment_screenshot = null
        proceedLead.value.payment_screenshot_name = null

        return
      }

      uploadScreenshotLoading.value = true
      store
        .dispatch('app-receipt/directUploadScreenshot', file)
        .then(response => {
          uploadScreenshotLoading.value = false
          if (response) {
            proceedLead.value.payment_screenshot = response.signed_id
            proceedLead.value.payment_screenshot_name = response.filename
          }
        })
        .catch(error => {
          uploadScreenshotLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while uploading screenshot. Please refresh!')
        })
    }
    const directUploadVisaReceipt = file => {
      if (file == null) {
        proceedLead.value.visa_receipt = null
        proceedLead.value.visa_receipt_name = null

        return
      }

      uploadVisaReceiptLoading.value = true
      store
        .dispatch('app-receipt/directUploadVisaReceipt', file)
        .then(response => {
          uploadVisaReceiptLoading.value = false
          if (response) {
            proceedLead.value.visa_receipt = response.signed_id
            proceedLead.value.visa_receipt_name = response.filename
          }
        })
        .catch(error => {
          uploadVisaReceiptLoading.value = false
          snackbarService.error(error.response.data.message || 'Something went wrong while uploading visa receipt. Please refresh!')
        })
    }
    const clearPaymentDetailNumbers = () => {
      proceedLead.value.trace_number = null
      proceedLead.value.partial_card_number = null
    }

    let timer = null
    watch([searchText], () => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        isLoading()
        fetchLeads()
      }, 200)
    })

    // Mounted
    onMounted(() => {
      fetchLeads()
      setTimeout(() => { fetchLeadCounts() }, 200)
      setTimeout(() => { fetchPaymentMethods() }, 400)

      // updateLeads()
    })

    // Unmounted
    onUnmounted(() => {
      if (store.hasModule(LEAD_APP_STORE_MODULE_NAME)) store.unregisterModule(LEAD_APP_STORE_MODULE_NAME)
      if (store.hasModule(RECEIPT_APP_STORE_MODULE_NAME)) store.unregisterModule(RECEIPT_APP_STORE_MODULE_NAME)
    })

    return {
      t,
      can,
      userData,
      userTeam,
      leads,
      loading,
      tablePagination,
      listLengthOptions,
      quotedTableColumns,
      quotedHideTableColumns,
      listLengthChange,
      pageChange,
      voidLead,
      searchText,
      isVoidDialogVisible,
      voidLoading,
      voidableLead,
      isIssueDialogVisible,
      issueLoading,
      issueLead,
      downloadPdf,
      downloadLoading,
      currentDownloadId,
      copyWhatsappText,
      proceedToIssue,
      proceedToIssuePaymentMethodId,
      uploadScreenshotLoading,
      uploadVisaReceiptLoading,
      proceedLead,
      paymentScreenshotRules,
      visaReceiptRules,
      directUploadScreenshot,
      directUploadVisaReceipt,
      paymentMethodOptions,
      clearPaymentDetailNumbers,

      icons: {
        mdiDownload,
        mdiPencilOutline,
        mdiDeleteOutline,
        mdiAlertCircleOutline,
        mdiMagnify,
        mdiEyeOutline,
        mdiClose,
        mdiFileDocumentOutline,
        mdiFileDocument,
        mdiContentCopy,
        mdiHelpCircleOutline,
        mdiArrowRightBox,
      },
    }
  },
}
</script>

<style lang="scss">
#lead-quoted-list {
  .lead-list-row-selection {
    max-width: 5.3rem;
  }
  .lead-appbar-item {
    max-width: 12.2rem;
  }
  .lead-appbar-color {
    background-color: #f0cc00;
  }
  .v-input.lead-appbar-item {
    background-color: white !important;
  }
  .theme--dark.lead-appbar-item input::placeholder,
  .theme--dark.lead-appbar-item .v-icon {
    color: #928C99 !important;
  }
}
</style>
